import { createSlice } from "@reduxjs/toolkit";
export const newVerificationRow = {
   note: "",
   billingCategory: ""
};

const verificationSessionFetching = {
   verificationSession: false,
   location: false,
   organization: false,
   account: false,
   billingCategory: false,
   sessionData: false
};

const initialState = {
   allBillingData: [],
   verificationDynamicColumn: [newVerificationRow],
   locationList: [],
   organizationList: [],
   accountList: [],
   sessionList: [1],
   isLoading: true,
   isFetching: verificationSessionFetching,
   isSaveOrConfirmClick: null,
   isVerificationSessionCompleted: false,
   showConfirmationModal: false
};

export const VerificationSlice = createSlice({
   name: "verification",
   initialState: initialState,
   reducers: {
      setAllBillingData: (state, action) => {
         state.allBillingData = action.payload;
      },
      setVerificationDynamicColumn: (state, action) => {
         state.verificationDynamicColumn = action.payload;
      },
      setLocationList: (state, action) => {
         state.locationList = action.payload;
      },
      setOrganizationList: (state, action) => {
         state.organizationList = action.payload;
      },
      setAccountList: (state, action) => {
         state.accountList = action.payload;
      },
      setSessionList: (state, action) => {
         state.sessionList = action.payload;
      },
      setLoading: (state, action) => {
         state.isLoading = action.payload;
      },
      setIsFetching: (state, action) => {
         state.isFetching = action.payload;
      },
      setIsSaveOrConfirmClick: (state, action) => {
         state.isSaveOrConfirmClick = action.payload;
      },
      setIsVerificationSessionCompleted: (state, action) => {
         state.isVerificationSessionCompleted = action.payload;
      },
      setShowConfirmationModal: (state, action) => {
         state.showConfirmationModal = action.payload;
      },
   },
});

export const {
   setAllBillingData,
   setVerificationDynamicColumn,
   setLocationList,
   setOrganizationList,
   setAccountList,
   setSessionList,
   setLoading,
   setIsFetching,
   setIsSaveOrConfirmClick,
   setIsVerificationSessionCompleted,
   setShowConfirmationModal
} = VerificationSlice.actions;
